import useTimer from "hooks/useTimer";
import styles from "components/sections/curation/EventTimerSection.module.scss";
import {useMemo, useState} from "react";

const EventTimerSection = (props) => {
    const {text, fontColor, timeColor, endsAt, backgroundColor, fixed, fontSize, height} = props;
    const {timeString} = useTimer(endsAt);
    const [error, setError] = useState(false);

    const splitText = useMemo(() => {
        const texts = text.split('{time}');
        setError(texts.length !== 2);
        return texts;
    }, [text])

    return (
        !error && (
            <div className={styles.timerContainer}
                 style={{
                     color: fontColor,
                     fontSize: fontSize,
                     backgroundColor: backgroundColor,
                     height: height,
                 }}>
                {
                    timeString && splitText.length === 2 &&
                    <div>
                        <span className={styles.defaultTimeSpan}>{splitText[0]}</span> <span className={styles.timeSpan}
                        style={{color: timeColor}}
                    >{timeString}</span> <span className={styles.defaultTimeSpan}>{splitText[1]}</span>
                    </div>
                }
            </div>
        )
    )
}

export default EventTimerSection;
